import { render, staticRenderFns } from "./KioskGuest.vue?vue&type=template&id=0c1ab7f6&"
import script from "./KioskGuest.vue?vue&type=script&lang=js&"
export * from "./KioskGuest.vue?vue&type=script&lang=js&"
import style0 from "./KioskGuest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KioskGuest.vue"
export default component.exports